import { useState, useEffect } from 'react';
import axios from 'axios';
import Main from '../../../component/Main.jsx';
import MergedTableHeader from '../../../component/common/dataGrid/MergedTableHeader.jsx';
import Loading from '../../../component/common/loading/Loading.jsx';
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component';

const BdTongTrmsEmogExceptCodeRate = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchFromdate: '',
        searchCheck2: currentMonth,
        searchYear: currentYear,
        searchGubun: "N",
        temp: '01'
    });
    const [dataList, setDataList] = useState([]);
    const [totalList, setTotalList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const firstDay = new Date(searchParams.searchYear, searchParams.searchCheck2, 1).getDate();
    const lastDay = new Date(searchParams.searchYear, searchParams.searchCheck2, 0).getDate();

    const handleInputChange = (e) => {
        const { name, type, value, checked } = e.target;
        if (name === 'searchGubun') {
            const gubun = checked ? 'Y' : 'N';
            setSearchParams(prev => ({
                ...prev,
                searchGubun: gubun,
                searchFromdate: prev.temp,
                temp: gubun === 'N' ? prev.searchFromdate : '',
            }));
            return;
        }
        setSearchParams(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const dataHead = [['선정연도', '선정연도', '기선정', '2013년', '2013년', '2013년', '2013년', '2013년', '2013년', '2014년', '2014년', '2014년', '2014년', '2015년', '2015년', '2015년', '2016년', '2016년', '2017년'],
    ['과목', '연번', '국립중앙의료원', '길병원', '경북대병원', '단국대병원', '목포한국병원', '원주세브란스병원', '부산대학교병원', '아주대학교병원', '울산대병원', '을지대병원', '전남대병원', '안동병원', '의정부성모병원', '충북대병원', '원광대병원', '제주한라병원', '경상대병원']];
    const dataColumn = ['BSCDDESC', 'RK', 'A1100052', 'A1400001', 'A1300002', 'A2400002', 'A2600011', 'A2200001', 'A1200002', 'A2100002', 'A1700004', 'A1600002', 'A1500002', 'A2700014', 'A2100040', 'A2300001', 'A2500001', 'A2900001', 'A2800001'];
    const apiCall = '/trmsapi/eschgsport/ecshgSportSpclstSttusListSearch.do';
    const apiCntCall = '/trmsapi/eschgsport/selectHnfCount.do';
    const excelFileName = `전담전문의 과별 통계_${searchParams.searchYear}_${searchParams.searchCheck2}${searchParams.searchGubun === "Y" ? `_${searchParams.searchFromdate}` : ''}`;
    const mergeConfig = [];

    const data = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(apiCall,
                { params: searchParams }
            );
            setDataList(response.data);
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    }

    const total = async () => {
        try {
            const response = await axios.get(apiCntCall,
                { params: searchParams }
            );
            setTotalList(Object.fromEntries(response.data.map(item => [item.EMOGCODE, item.CNT])));
            setIsLoading(false);
            setIsSearched(true);
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    }

    const search = () => {
        data();
        total();
    }

    const computeRowSpans = (dataList, mergeConfig = [], allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));

        // 병합 대상 컬럼 처리
        mergeConfig.forEach(({ key: colKey, row, nullable }) => {
            let prevValue = null;
            let startIndex = 0;
            let mergeCount = 1;

            for (let i = 0; i < dataList.length; i++) {
                const currentValue = dataList[i][colKey];
                const isMergeable = nullable ? currentValue === prevValue : (currentValue === prevValue && currentValue !== '' && currentValue !== null);
                if (isMergeable) {
                    if (row == null || mergeCount < row) {
                        rowSpans[startIndex][colKey] += 1;
                        rowSpans[i][colKey] = 0;
                        mergeCount += 1;
                    } else {
                        rowSpans[i][colKey] = 1;
                        startIndex = i;
                        mergeCount = 1;
                    }
                } else {
                    rowSpans[i][colKey] = 1;
                    startIndex = i;
                    mergeCount = 1;
                    prevValue = currentValue;
                }
            }
        });

        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });
        return rowSpans;
    };

    const rowSpans = computeRowSpans(dataList, mergeConfig ?? [], dataColumn);
    const { lightBackColor, borderColorGray } = useDynamicStyle();

    useEffect(() => {
        search();
    }, [searchParams.searchFromdate]);

    // Dynamic Style Hook
    const { fontColor, primaryBackColor } = useDynamicStyle();

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>조회년월</th>
                            <td>
                                <select id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 11 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year}년
                                            </option>
                                        );
                                    })}
                                </select>
                                &nbsp;
                                <select id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month}월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <th>기준일자</th>
                            <td>
                                <select id="searchFromdate"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                    disabled={searchParams.searchGubun === 'N'}
                                >
                                    {Array.from({ length: lastDay - firstDay + 1 }, (_, i) => {
                                        const day = (firstDay + i).toString().padStart(2, '0');
                                        return (
                                            <option key={day} value={day}>
                                                {day}
                                            </option>
                                        );
                                    })}
                                </select>
                                &nbsp;&nbsp;&nbsp;
                                <span>
                                    <input type="checkbox" id="searchGubun" name="searchGubun" checked={searchParams.searchGubun === 'Y'} onChange={handleInputChange} />
                                    <label htmlFor="searchGubun">기준 적용일</label>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className={fontColor}>{dataList.length}</strong>건</span>
                <div className='btn_container'>
                    <button onClick={search} disabled={isLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Icons.Search16w />조회</button>
                    <ExcelDownload
                        excelHead={dataHead}
                        excelData={dataList.concat({ ...totalList, BSCDDESC: '총원(국비/자비)' })}
                        searched={isSearched}
                        dataCode={dataColumn}
                        excelFileName={excelFileName}
                    />
                </div>
            </div>
            {isLoading ? <Loading /> :
                <>
                    <div className='data_grid_container'>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                        <div className={`data_list_table ${isSearched ? 'grid-animation' : ''}`}>
                            <table>
                                <MergedTableHeader
                                    headers={dataHead}
                                />
                                <tbody>
                                    {dataList.length === 0 ? (
                                        <tr>
                                            <td colSpan={1000}>
                                                <span className={`data_empty ${lightBackColor}`}>
                                                    {isSearched ? <Icons.EmptySalgu /> : <Icons.NullSalgu />}
                                                    {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                </span>
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {Array.isArray(dataList) &&
                                                dataList.map((item, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {dataColumn.map((col, colIndex) => {
                                                            const span = rowSpans[rowIndex]?.[col];
                                                            const isSticky = colIndex === 0 ? { left: 0, background: 'var(--tr-row)' }
                                                                : colIndex === 1 ? { left: 108, background: 'var(--tr-odd)' }
                                                                    : {};
                                                            if (span) {
                                                                return (
                                                                    <td key={colIndex} rowSpan={span} style={isSticky}>
                                                                        {item[col] ?? '-'}
                                                                    </td>
                                                                );
                                                            }
                                                            return null;
                                                        })}
                                                    </tr>
                                                ))}
                                        </>
                                    )}
                                </tbody>
                                <tfoot className='sticky z-2 bottom-0 bg_tr_non text-center h-8'>
                                    <tr>
                                        {dataColumn.map((col, colIndex) => {
                                            const value = col === 'BSCDDESC' ? '총원(국비/자비)' : (totalList[col] ?? '-');
                                            const isSticky = colIndex === 0 ? { position: 'sticky', left: 0, background: 'var(--tr-non)', zIndex: 2 }
                                                : colIndex === 1 ? { position: 'sticky', left: 108, background: 'var(--tr-non)', zIndex: 2 }
                                                    : {};
                                            return (
                                                <td key={`total-${colIndex}`} style={isSticky}>
                                                    {value}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <p className='mt-2'>※ 참고 : 전문의 이름 (국비여부/자비여부)</p>
                </>
            }
        </Main>
    )
}

export default BdTongTrmsEmogExceptCodeRate;